import { NgModule } from '@angular/core';
import { rechnungsVorlagenQueryModule, ReisekostenabrechnungenQueryModule, ReisekostenabrechnungQueryModule } from '.';

@NgModule({
  declarations: [],
  imports: [rechnungsVorlagenQueryModule, ReisekostenabrechnungQueryModule, ReisekostenabrechnungenQueryModule],
  exports: [rechnungsVorlagenQueryModule, ReisekostenabrechnungQueryModule, ReisekostenabrechnungenQueryModule],
})
export class FinanzenQuerysModule {}
